const STORAGE_KEY = 'frontdoor_report_library_sidebar_collapsed';

export function getStoredLibrarySidebarCollapsed(): boolean {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored === null) {
            return false;
        }

        return JSON.parse(stored) === true;
    } catch {
        return false;
    }
}

export function setStoredLibrarySidebarCollapsed(isCollapsed: boolean): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(isCollapsed));
}
